import React, { useMemo } from "react";
import TaskBoard from "../../serviceProvider/components/tasks/TaskBoard";
import "../../serviceProvider/components/tasks/tasks.css";

// Task board for an employee's profile and a milestone, in the same design as the Tasks page.
// `tasks` may be a flat list or the older { Pending: [...], "In Progress": [...] } shape.
export const TasksComponent = ({ tasks, onTaskReArrange, updateData, employeeView }) => {
  const list = useMemo(
    () => (Array.isArray(tasks) ? tasks : Object.values(tasks || {}).flat()),
    [tasks]
  );

  return (
    <div className="desk-wrapper desk-wrapper--embedded">
      <TaskBoard
        tasks={list}
        onChanged={updateData}
        readOnly={employeeView}
        onMoved={(task, from, to) => onTaskReArrange?.(`Marked task as ${to}`)}
      />
    </div>
  );
};

export default TasksComponent;
